import {
  CREATE_PAYMENTMETHOD_NEW_RECORD,
  CREATE_PAYMENTMETHOD_NEW_RECORD_SUCCESS,
  CREATE_PAYMENTMETHOD_NEW_RECORD_ERROR,  
  
  GET_PAYMENTMETHOD_NEW_RECORD,
  GET_PAYMENTMETHOD_NEW_RECORD_SUCCESS,
  GET_PAYMENTMETHOD_NEW_RECORD_ERROR,  

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";

export const getPaymentMethodItemNewRecord = (paymentmethodid, history) => ({
    type: GET_PAYMENTMETHOD_NEW_RECORD,
    payload: {paymentmethodid, history}
  });

export const getPaymentMethodItemNewRecordSuccess = (recordCreated) => ({
  type: GET_PAYMENTMETHOD_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getPaymentMethodItemNewRecordError = (message) => ({
  type: GET_PAYMENTMETHOD_NEW_RECORD_ERROR,
  payload: { message },
});

export const createPaymentMethodItemNewRecord = (newRecord, history) => ({
    type: CREATE_PAYMENTMETHOD_NEW_RECORD,
    payload: {newRecord, history}
  });

export const createPaymentMethodItemNewRecordSuccess = (recordCreated) => ({
  type: CREATE_PAYMENTMETHOD_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createPaymentMethodItemNewRecordError = (message) => ({
  type: CREATE_PAYMENTMETHOD_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});